"use server";

import { randomUUID } from "node:crypto";

import { sendPasswordRecoveryEmail } from "@/lib/auth/password-recovery-email";
import { passwordRecoveryConfirmUrl } from "@/lib/auth/password-recovery";
import { createSupabaseAdminClient } from "@/lib/supabase/admin";

export type ForgotPasswordState = {
  message?: string;
  status: "idle" | "success" | "error";
};

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export async function requestPasswordReset(
  _previous: ForgotPasswordState,
  formData: FormData,
): Promise<ForgotPasswordState> {
  const value = formData.get("email");
  const email = typeof value === "string" ? value.trim().toLowerCase() : "";
  if (!emailPattern.test(email)) {
    return { status: "error", message: "Enter a valid email address." };
  }

  try {
    const admin = createSupabaseAdminClient();
    const result = await admin.auth.admin.generateLink({
      email,
      type: "recovery",
    });
    const tokenHash = result.data?.properties?.hashed_token;
    if (!result.error && tokenHash) {
      await sendPasswordRecoveryEmail({
        actionUrl: passwordRecoveryConfirmUrl(
          process.env.THREADOPS_APP_URL ?? "http://127.0.0.1:3000",
          tokenHash,
        ),
        email,
        idempotencyKey: `password-recovery:${randomUUID()}`,
      });
    }
  } catch {
    // Keep the response neutral so account existence and delivery state are not disclosed.
  }

  return {
    status: "success",
    message: "If that address belongs to a ThreadOps account, a recovery link has been sent.",
  };
}
